module.exports = __webpack_public_path__ + "img/bg.32f2c2eb.jpeg";